/**
 * The slide's eyebrow (NEWS-28…36): "01 —— No celular". 12px caps in the
 * stage's light blue (`EYEBROW_COLOR`), a thin rule between the two parts.
 */
/**
 * Light blue of the stage's eyebrows: ≥ 4.5:1 on the lightest pixel of the
 * stage gradient under the copy (`#6FA0FF` measured 4.42:1 on the cover).
 */
export const EYEBROW_COLOR = '#8DB4FF';

export function Eyebrow({ lead, trail }: { lead: string; trail?: string }) {
  return (
    <div
      className="flex flex-wrap items-center gap-x-3.5 gap-y-2 text-xs font-semibold uppercase tracking-[0.16em]"
      style={{ color: EYEBROW_COLOR }}
    >
      <span className="whitespace-nowrap">{lead}</span>
      {trail !== undefined && (
        <>
          <span
            aria-hidden="true"
            className="h-px w-12 flex-none bg-current opacity-50"
          />
          <span className="whitespace-nowrap">{trail}</span>
        </>
      )}
    </div>
  );
}
